module.exports = {"id":"172939","name":"Keiren Westwood","rating":"75","photo":"./data/images/photos/4/172939.png","club":{"name":"Sheffield Wed.","logo":"./data/images/clubs/SheffieldWed..png"},"positions":["G"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/KeirenWestwood0.json
// module id = 2306
// module chunks = 0